import React from 'react';

const SvgQuienesSomos: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`w-8 h-8 p-0.5 ${className ?? ''}`}
    fill="none"
    stroke="currentColor"
    strokeWidth={1} // puedes probar con 2.5 o 3 si lo quieres aún más marcado
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18.852 12.632a1 1 0 0 0 0-1.264C18.173 10 15.507 7 12 7s-6.173 3-6.852 4.368a1 1 0 0 0 0 1.264C5.827 14 8.493 17 12 17s6.173-3 6.852-4.368Zm-6.852 3.368c-3.342 0-5.58-3.056-5.955-3.812a.396.396 0 0 1 0-.375C6.549 10.795 8.898 8 12 8s5.451 2.795 5.955 3.812a.396.396 0 0 1 0 .375c-.504 1.018-2.853 3.812-5.955 3.812ZM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM5.293 6.5L.069.776.776.069l5.224 5.224V1h1v4.5A1.5 1.5 0 0 1 5.5 7H1v-1h4.293Zm11.719-.488-.012-4.511 1-.002.011 4.283L23.224.069l.707.707-5.224 5.224h4.293v1h-4.5a1.488 1.488 0 0 1-1.488-1.488Zm-10.012 12.988v4.5h-1v-4.293L.776 23.931l-.707-.707 5.224-5.224H1v-1h4.5a1.5 1.5 0 0 1 1.5 1.5Zm11.707-.5 5.224 5.224-.707.707-5.213-5.213-.011 4.283-1-.002.012-4.512a1.487 1.487 0 0 1 1.488-1.487h4.5v1h-4.293Z" />
  </svg>
);

export default SvgQuienesSomos;
